import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip, Menu, MenuItem, ListItemText, ListItemIcon
} from '@mui/material';
import { Ic } from '../../shell/Icons';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CompareIcon from '@mui/icons-material/Compare';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import BugReportIcon from '@mui/icons-material/BugReport';
import CategoryIcon from '@mui/icons-material/Category';
import CalculateIcon from '@mui/icons-material/Calculate';
import BuildIcon from '@mui/icons-material/Build';

/**
 * AI Features dropdown menu component for the item details toolbar
 */
const AiFeatures = ({
  handleReviewWithAI,
  handleCheckConsistency,
  handleDecompose,
  handleGenerateTests,
  handleIdentifyEntities,
  onCalculateLimitsClick,
  onImplementClick
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  return (
    <>
      <Tooltip title="AI-powered requirement analysis tools">
        {/* Native design-system button so it matches the rest of the action bar
            (a MUI <Button> here rendered taller/wider than its .btn siblings). */}
        <button
          type="button"
          className="btn secondary"
          onClick={handleClick}
          data-testid="ai-tools-button"
        >
          <Ic name="spark" />AI Tools
        </button>
      </Tooltip>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem data-testid="ai-review" 
          onClick={() => {
            handleReviewWithAI();
            handleClose();
          }}
        >
          <ListItemIcon>
            <AutoFixHighIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Review Requirement" />
        </MenuItem>
        
        <MenuItem data-testid="ai-consistency" 
          onClick={() => {
            handleCheckConsistency();
            handleClose();
          }}
        >
          <ListItemIcon>
            <CompareIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Check Consistency" />
        </MenuItem>
        
        <MenuItem data-testid="ai-decompose" 
          onClick={() => {
            handleDecompose();
            handleClose();
          }}
        >
          <ListItemIcon>
            <SplitscreenIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Decompose Requirement" />
        </MenuItem>
        
        <MenuItem data-testid="ai-tests" 
          onClick={() => {
            handleGenerateTests();
            handleClose();
          }}
        >
          <ListItemIcon>
            <BugReportIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Generate Tests" />
        </MenuItem>
        
        <MenuItem data-testid="ai-entities" 
          onClick={() => {
            handleIdentifyEntities();
            handleClose();
          }}
        >
          <ListItemIcon>
            <CategoryIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Identify Entities" />
        </MenuItem>
        
        <MenuItem data-testid="ai-calculate" 
          onClick={() => {
            onCalculateLimitsClick?.();
            handleClose();
          }}
        >
          <ListItemIcon>
            <CalculateIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Calculate Limitations" />
        </MenuItem>

        <MenuItem data-testid="ai-implement" 
          onClick={() => {
            onImplementClick?.();
            handleClose();
          }}
        >
          <ListItemIcon>
            <BuildIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Implement Requirement" />
        </MenuItem>
      </Menu>
    </>
  );
};

AiFeatures.propTypes = {
  handleReviewWithAI: PropTypes.func,
  handleCheckConsistency: PropTypes.func,
  handleDecompose: PropTypes.func,
  handleGenerateTests: PropTypes.func,
  handleIdentifyEntities: PropTypes.func,
  onCalculateLimitsClick: PropTypes.func,
  onImplementClick: PropTypes.func
};

export default AiFeatures;
